import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '' }
  },

 
  {
    path: '/teachHall',
    name: 'teachHall',
    component: () => import('../views/teachHall/index.vue'),
    props: true,
    meta: { title: '', name: '名师堂' }
  },
  {
    path: '/teachHallDetail',
    name: 'teachHallDetail',
    component: () => import('../views/teachHall/teachHallDetail/index.vue'),
    meta: { title: '', name: '名师详情'},

  },
  {
    path: '/resourceDetail',
    name: 'resourceDetail',
    component: () => import('../views/resourceDetail/index.vue'),
    props: true,
    meta: { title: '', name: '资源详情' }
  },
  {
    path: '/resourceList',
    name: 'resourceList',
    component: () => import('../views/resourceList/index.vue'),
    meta: { title: '', name: '资源列表' }
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import('../views/helpCenter/index.vue'),
    meta: { title: '', name: '帮助中心' },

  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/newsDetail/index.vue'),
    meta: { title: '', name: '' }
  },
  {
    path: '/newsInfo',
    name: 'newsInfo',
    component: () => import('../views/newsInfo/index.vue'),
    meta: { title: '', name: '新闻中心' },

  },{
    path: '/login',
    name: 'login',
    component: () => import('../views/personCenter/login/login.vue'),
    meta: { title: '', name: '用户登录' },

  },
  {
    path: '/personCenter',
    name: 'personCenter',
    component: () => import('../views/personCenter/index.vue'),
    meta: { title: '', name: '个人中心' },

  },
  {
    path: '/forgetPass',
    name: 'forgetPass',
    component: () => import('../views/personCenter/forgetPass.vue'),
    meta: { title: '', name: '忘记密码' },

  },
  {
    path: '/noticeList',
    name: 'noticeList',
    component: () => import('../views/noticeList/index.vue'),
    meta: { title: '', name: '通知公告' },

  },
  // {
  //   path: '/collectList',
  //   name: 'collectList',
  //   component: () => import('../views/collectList/index.vue'),
  //   meta: { title: '', name: '我的收藏' },

  // }
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  const nav_index = localStorage.getItem('a_index')
  if (to.path == '/') {
    store.commit('set_nav_index', 0)
  } else if (to.path == '/resourceList' || to.path == '/resourceDetail') {
    if(to.query.type==1){
      store.commit('set_nav_index', 1)
    }else if(to.query.type==2){
      store.commit('set_nav_index', 2)
    }else if(to.query.type==3){
      store.commit('set_nav_index', 3)
    }else if(to.query.type==4){
      store.commit('set_nav_index', 4)
    }
    
  } else if(to.path == '/personCenter'){
    store.commit('set_nav_index', -1)
  }else if(to.path == '/newsInfo'){
    store.commit('set_nav_index', 6)
  } else {
    store.commit('set_nav_index', nav_index)
  }
  next()
})

export default router
